import { render, staticRenderFns } from "./RiasocResultsBody.vue?vue&type=template&id=23eac0ca&scoped=true&"
import script from "./RiasocResultsBody.vue?vue&type=script&lang=js&"
export * from "./RiasocResultsBody.vue?vue&type=script&lang=js&"
import style0 from "./RiasocResultsBody.vue?vue&type=style&index=0&id=23eac0ca&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eac0ca",
  null
  
)

export default component.exports